<template>
  <v-card>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xl6 lg6 md6 sm6 hidden-xs-only>
          <v-btn style="margin:0px" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xl6 lg6 md6 sm6 xs12 text-lg-right>
          <v-text-field
            style="padding:0px; margin:0px"
            id="searchBox"
            single-line
            v-model="searchValue"
            @keydown.enter="enter"
            placeholder="Buscar"
            append-icon="search"
            light
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider style="margin:0px"></v-divider>
    <v-card-text style="padding-top:0px">
      <v-data-table
        flat
        v-bind:pagination.sync="pagination"
        item-key="id"
        :items="bonusCompliancePending"
        :headers="headers"
        class="v-table-list compact theme--light"
        :rows-per-page-text="$t('message.rowsByPage')"
      >
        <template slot="headers" scope="props">
          <tr class="border-buttom">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td class="text-xs-left cut-text">{{ props.item.agencyName }}</td>
            <td class="text-xs-left cut-text">{{ props.item.bonusType }}</td>
            <td class="text-xs-left cut-text">{{ props.item.lineBusiness }}</td>
            <td class="text-xs-left cut-text">{{ viewTime(props.item.commercialTime,0) }}</td>
            <td class="text-xs-left cut-text">{{viewTime(props.item.commercialTime,1)}}</td>
            <td class="text-xs-left cut-text">{{ props.item.endorsement }}</td>
            <td class="text-xs-left cut-text">{{ nzDate(props.item.creationDate)  }}</td>
            <td class="text-xs-left cut-text">{{ props.item.efficientIncome | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.budgetN1 }}</td>
            <td class="text-xs-left cut-text">{{ props.item.bonusN1 }}</td>
            <td class="text-xs-left cut-text">{{ props.item.budgetN2 }}</td>
            <td class="text-xs-left cut-text">{{ props.item.bonusN2 }}</td>
           <td class="text-xs-left cut-text"> {{ Math.round(Number(props.item.Siniestralidad)) }}%</td>

            
          </tr>
        </template>
        <template slot="no-data">
          <div>{{$t('message.noPreliquidations')}}</div>
        </template>
        <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
      </v-data-table>
       <v-row no-gutters class="mt-4">
        <v-col cols="12" class="considerations-box">
          <div><strong>Consideraciones:</strong></div>
          <div>
            Recuerda que los bonos son válidos por <strong>90&nbsp;días</strong> a partir de la fecha de creación.
          </div>
            <div>
          Tomar en cuenta que el indicador de siniestralidad no aplica para  <strong>GARANTÍAS.&nbsp;</strong> 
          </div>
          
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

export default {
  computed: {
    ...mapGetters([
      "loadingBonusCompliance",
      "bonusCompliancePending",
      "agency"
    ])
  },
  mounted() {
    this.$store.dispatch("getBonusCompliancePending");
  },
   filters: {
    percent(value) {
      if (value == null || value === '') return '';
      return Number(value).toFixed(2) + '%';
    }
  },
  methods: {
     
    nzDate: nzDate,
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.bonusCompliancePending.slice();
    },
    changeSort(column) {
      this.selectedValue = null;
      this.selectRow = [];
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    viewTime(commercialTime, type) {
      if (type == 0) {
        var anio = commercialTime.toString();
        var value = anio.substring(0, 4);
        return value;
      }
      if (type == 1) {
        var semana = commercialTime.toString();
        var value = semana.substring(4, semana.length);
        return value;
      }
    },
    refresh() {
      this.$store.dispatch("getBonusCompliancePending");
    },
    enter() {
      if (this.searchValue != "") {
        this.$store.dispatch("getBonusCompliancePending", this.searchValue);
      } else {
        this.$store.dispatch("getBonusCompliancePending");
      }
    }
  },
  watch: {
    loadingBonusCompliance(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      this.$store.dispatch("getBonusCompliancePending");
    }
  },
  data() {
    return {
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "date"
      },
      selected: [],
      headers: [
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.Agency"),
          value: "sucursal",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.bonusType"),
          value: "bonusType",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.businessLine"),
          value: "businessLine",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.businessYear"),
          value: "commercialTime",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.businessWeek"),
          value: "commercialTime",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.endorsement"),
          value: "endorsement",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.datePreliquidation"),
          value: "creationDate",
          width: "1%"
        },

        {
          align: "left",
          sortable: true,
          text: i18n.t("message.efficientIncome"),
          value: "efficientIncome",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.budgetN1"),
          value: "budgetN1",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.bonusValueN1"),
          value: "bonusN1",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.budgetN2"),
          value: "budgetN2",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.bonusValueN2"),
          value: "bonusN2",
          width: "1%"
        },
          {
          align: "left",
          sortable: true,
          text: i18n.t("message.Siniestralidad"),
          value: "Siniestralidad",
          width: "1%"
        }
      ]
    };
  }
};
</script>